exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".groupData__wrapper___26UlT {\n  padding: 15px 15px 24px 15px;\n  margin-bottom: 14px;\n  background-color: #fff; }\n  .groupData__wrapper___26UlT .groupData__sectionName___2YLvd {\n    font-size: 15px;\n    font-weight: 600;\n    line-height: 22px;\n    color: #000000;\n    margin: 0; }\n  .groupData__wrapper___26UlT .groupData__content___3ywtg {\n    margin-top: 16px;\n    color: #000000;\n    display: grid; }\n    .groupData__wrapper___26UlT .groupData__content___3ywtg.groupData__valueOnly___2WqXS, .groupData__wrapper___26UlT .groupData__content___3ywtg.groupData__valueWithTitle___3q13i {\n      grid-template-columns: 50% 50%; }\n    @media (max-width: 576px) {\n      .groupData__wrapper___26UlT .groupData__content___3ywtg.groupData__valueOnly___2WqXS, .groupData__wrapper___26UlT .groupData__content___3ywtg.groupData__valueWithTitle___3q13i {\n        grid-template-columns: 100%; } }\n", ""]);

// exports
exports.locals = {
	"wrapper": "groupData__wrapper___26UlT",
	"sectionName": "groupData__sectionName___2YLvd",
	"content": "groupData__content___3ywtg",
	"valueOnly": "groupData__valueOnly___2WqXS",
	"valueWithTitle": "groupData__valueWithTitle___3q13i"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/AdDetailsPage/AdDetailsPageMobile/DetailsSection/GroupData/groupData.scss
// module id = 4408
// module chunks = 6